import React, { useState } from "react";
import styled from "@emotion/styled";
import Ticker from "react-ticker";

// Utils
import { PageGutter, Colors } from "../../../common/utils/constants";

// Components
import Typography from "../../../common/components/Typography";

// Black Images
import BlackLogo1 from "../../../images/partners/advtech_black.png";
import BlackLogo2 from "../../../images/partners/curro_black.png";
import BlackLogo3 from "../../../images/partners/foundation_botnar_black.png";
import BlackLogo4 from "../../../images/partners/future_africa_2_black.png";
import BlackLogo5 from "../../../images/partners/it_master_black.png";
import BlackLogo6 from "../../../images/partners/launch_africa_black.png";
import BlackLogo7 from "../../../images/partners/odilo_black.png";
import BlackLogo8 from "../../../images/partners/optimi_black.png";
import BlackLogo9 from "../../../images/partners/oxford_black.png";
import BlackLogo10 from "../../../images/partners/smd_black.png";

const Container = styled.section`
    padding: ${PageGutter};
`;

const Items = styled.div`
    display: flex;
    flex-direction: row;
`;

const Item = styled.div`
    background-image: url(${(props) => props.image});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;

    width: 200px;
    height: 100px;
    margin: 10px 15px;
`;

const Partners = () => {
    const TopLogoPrtners = [
        BlackLogo1,
        BlackLogo2,
        BlackLogo3,
        BlackLogo4,
        BlackLogo5,
    ];
    const BottomLogoPrtners = [
        BlackLogo6,
        BlackLogo7,
        BlackLogo8,
        BlackLogo9,
        BlackLogo10,
    ];
    return (
        <Container>
            <Typography variant="h4" pb={8}>
                Our Partners
            </Typography>
            <Ticker speed={6}>
                {() => (
                    <Items>
                        {TopLogoPrtners.map((src, index) => (
                            <Item image={src} key={index} />
                        ))}
                    </Items>
                )}
            </Ticker>
            <Ticker speed={4}>
                {() => (
                    <Items>
                        {BottomLogoPrtners.map((src, index) => (
                            <Item image={src} key={index} />
                        ))}
                    </Items>
                )}
            </Ticker>
        </Container>
    );
};

export default Partners;
